<template>
  <div>
    <v-layout wrap>
      <v-flex xs12 mt-6 text-end pr-3>
       <v-btn @click="isShowingCreateStripePlanDialog = true" small class="primary white--text">
        <v-icon small class="mr-2">mdi-plus</v-icon>
        Créer un nouveau pricing
       </v-btn>
      </v-flex>
    </v-layout>
      

    <v-dialog v-model="isShowingCreateStripePlanDialog" width="50%" :persistent="isCreateStripePlanPending">
      <v-card class="pa-6">
        <v-layout row wrap>
          <v-flex xs12 text-center>
              <h3>Créer un pricing</h3>
          </v-flex>
        </v-layout>
        <div v-if="isCreateStripePlanPending">
          <v-progress-linear indeterminate color="primary" class="mt-3"></v-progress-linear>
        </div>
        <div v-else>
          <v-layout row wrap justify-space-around>
            <v-flex xs12 pl-3 mt-8 mb-4>
              <v-select
                v-model="newPlan.productId"
                label="Nombre de dossiers par mois"
                :items="products"
                item-text="numberOfDossiersPerMonth"
                item-value="productId"
                outlined
                dense
                hide-details
              ></v-select>
            </v-flex>
            <v-flex xs12 pl-3>
              <v-checkbox v-model="newPlan.isYearly" label="Abonnement annuel" outlined dense hide-details/>
            </v-flex>
            <v-flex xs12 pl-3 mt-3>
              <v-text-field
                v-model.number="newPlan.amount"
                :label="`Montant ${newPlan.isYearly ? 'ANNUEL' : 'MENSUEL'} (€)`"
                type="number"
                min="0"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-flex>
            <v-flex xs12 mt-4 text-center v-if="!(!newPlan.productId || !(newPlan.amount || newPlan.amount === 0))">
              <div v-if="newPlan.isYearly">
                Id du futur nouveau pricing: {{ `${products.find(x => x.productId === newPlan.productId).numberOfDossiersPerMonth}_${Math.round(newPlan.amount/11)}_yearly` }}
              </div>
              <div v-else>
                Id du futur nouveau pricing: {{ `${products.find(x => x.productId === newPlan.productId).numberOfDossiersPerMonth}_${newPlan.amount}` }}
              </div>
              <v-btn @click="createStripePlan" class="secondary white--text mt-3 mb-2">Créer le pricing</v-btn>
            </v-flex>
          </v-layout>
        </div>
      </v-card>
    </v-dialog>
  </div>  
</template>

<script>
import { getStripePlans } from '@/helpers/subscriptions.js';

export default {
  data: () => ({
    isShowingCreateStripePlanDialog: false,
    isCreateStripePlanPending: false,
    plans: [],
    products: [],
    newPlan: {
      productId: null,
      isYearly: false,
      amount: null,
    }
  }),
  async mounted() {
    const isProduction = Boolean(process.env.VUE_APP_ENV === 'production')
    const plans = await getStripePlans(this.$db);
    this.plans = plans.monthlyPlans.concat(plans.hiddenMonthlyPlans).concat(plans.yearlyPlans).concat(plans.hiddenYearlyPlans)

    const productsDict = {}
    for (let plan of this.plans) {
      const productId = isProduction ? plan.stripeProductIdProd : plan.stripeProductIdDev
      if (productId && !['solo', 'soloYearly', 'standard', 'standardYearly'].includes(plan.id)) {
        productsDict[productId] = plan.numberOfDossiersPerMonth
      }
    }

    this.products = Object.entries(productsDict).map(x => {
      return {
        productId: x[0],
        numberOfDossiersPerMonth: x[1]
      }
    }).sort((a,b) => a.numberOfDossiersPerMonth - b.numberOfDossiersPerMonth)

  },
  methods: {
    async createStripePlan() {
      this.isCreateStripePlanPending = true
      let monthlyAmountIfItWereMonthly = null;
      let amountBeforeYearlyDiscount = null;
      if (this.newPlan.isYearly) {
        monthlyAmountIfItWereMonthly = Math.round(this.newPlan.amount/11)
        amountBeforeYearlyDiscount = 12 * monthlyAmountIfItWereMonthly
      }
      const numberOfDossiersPerMonth = this.products.find(x => x.productId === this.newPlan.productId).numberOfDossiersPerMonth
      await this.$functions.httpsCallable('createStripePlan')({
        amount: this.newPlan.amount,
        monthlyAmountIfItWereMonthly,
        amountBeforeYearlyDiscount,
        isYearly: this.newPlan.isYearly,
        productId: this.newPlan.productId,
        numberOfDossiersPerMonth,
      })
      this.$router.push(`/admin?activeTab=listCompanies`)
      this.$router.go()
    }
  }
}
</script>